<template>
    <div class="myaccount-wrapper">
        <v-tabs icons-and-text class="my-account-tabs-container">
            <v-tab class="my-profile-tab"></v-tab>

            <v-tab-item>
                <v-card flat class="my-profile-card">
                    <v-card-text>
                        <Myprofile :preselectedTab="preselectedTab"></Myprofile>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import Myprofile from "../../components/Myprofile";

export default {
    name: "Myaccount",
    props: {
        preselectedTab: String
    },
    components: {Myprofile},
    head: {
        title: 'My account | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'my-account'
        }
    },
}
</script>

<style scoped>

</style>

<style>
.v-tabs--icons-and-text .v-tab {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: initial;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
}

.my-account .header-toolbar {
    box-shadow: none;
}

.myaccount-card-container-header {
    font-size: 25px;
    margin-bottom: 55px;
}

.myaccount-card-container-header .v-icon.v-icon {
    font-size: 60px;
    color: #014e7a;
}

.v-tabs--vertical > .v-window {
    background: #f7f8f9;
    padding: 25px 50px;
}

.theme--light.v-card {
    background: #f7f8f9;
}

.darkmode .theme--light.v-card {
    background: #2E313B;
    border-radius: 0;
}

.v-tabs--vertical > .v-tabs-bar,
.v-tabs--vertical > .v-window {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
}

.my-profile-tab i {
    width: 25px;
    height: 25px;
    background-image: url('../../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -100px -153px;
}

.my-profile-tab.v-tab--active i {
    background-position: -128px -153px;
}

.address-book-tab i {
    width: 25px;
    height: 25px;
    background-image: url('../../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -100px -129px;
}

.address-book-tab.v-tab--active i {
    background-position: -128px -129px;
}

.my-trades-tab i {
    width: 25px;
    height: 25px;
    background-image: url('../../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -100px -104px;
}

.my-trades-tab.v-tab--active i {
    background-position: -128px -104px;
}

.my-invoices-tab i {
    width: 25px;
    height: 25px;
    background-image: url('../../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -100px -78px;
}

.my-invoices-tab.v-tab--active i {
    background-position: -128px -78px;
}

.my-sales-tab i {
    width: 25px;
    height: 25px;
    background-image: url('../../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -100px -53px;
}

.my-sales-tab.v-tab--active i {
    background-position: -128px -53px;
}

.my-deliveries-tab i {
    width: 25px;
    height: 25px;
    background-image: url('../../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -100px -28px;
}

.my-deliveries-tab.v-tab--active i {
    background-position: -128px -28px;
}

.my-profile-tab,
.address-book-tab,
.my-trades-tab,
.my-invoices-tab,
.my-sales-tab,
.my-deliveries-tab {
    padding-left: 5px;
    padding-right: 20px;
}

.address-book-tab,
.my-invoices-tab {
    margin: 0 30px;
}

.my-deliveries-tab {
    margin-left: 30px;
}

.my-profile-tab i,
.address-book-tab i,
.my-trades-tab i,
.my-invoices-tab i,
.my-sales-tab i,
.my-deliveries-tab i {
    margin-right: 5px;
}

.darkmode .theme--light.v-tabs .my-profile-tab,
.darkmode .theme--light.v-tabs .address-book-tab,
.darkmode .theme--light.v-tabs .my-trades-tab,
.darkmode .theme--light.v-tabs .my-invoices-tab,
.darkmode .theme--light.v-tabs .my-sales-tab,
.darkmode .theme--light.v-tabs .my-deliveries-tab {
    color: #ffffff;
}

.darkmode .theme--light.v-tabs .my-profile-tab.v-tab--active,
.darkmode .theme--light.v-tabs .address-book-tab.v-tab--active,
.darkmode .theme--light.v-tabs .my-trades-tab.v-tab--active,
.darkmode .theme--light.v-tabs .my-invoices-tab.v-tab--active,
.darkmode .theme--light.v-tabs .my-sales-tab.v-tab--active,
.darkmode .theme--light.v-tabs .my-deliveries-tab.v-tab--active {
    color: #E5C57B;
}

.my-account-tabs-container {
    position: relative;
}

.my-account-tabs-container > .v-tabs-bar {
    display: none;
}

.darkmode .my-account-tabs-container .v-tabs-slider-wrapper {
    color: #E5C57B;
}

.darkmode .my-account-tabs-container .v-tabs-bar {
    background: #2E313B !important;
    border-color: #494E5C;
}

.darkmode .theme--light.v-tabs-items {
    background: #2E313B !important;
}

.v-tab.v-tab {
    text-transform: none;
}

.v-tabs--vertical.my-account-tabs-container > .v-window {
    padding: 14px;
}

.my-account-tabs-container .v-slide-group__wrapper {
    max-width: 1280px;
    margin: 0 auto;
}

@media (min-width: 0) {
    .v-tabs--vertical > .v-tabs-bar {
        -ms-flex-preferred-size: 100%;
        flex-basis: 100%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 100%;
    }

    .v-tabs--vertical > .v-window {
        -ms-flex-preferred-size: 100%;
        flex-basis: 100%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 100%;
    }
}

@media (min-width: 600px) {
    .v-tabs--vertical > .v-tabs-bar {
        -ms-flex-preferred-size: 16.6666666667%;
        flex-basis: 16.6666666667%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 16.6666666667%;
    }

    .v-tabs--vertical > .v-window {
        -ms-flex-preferred-size: 83.3333333333%;
        flex-basis: 83.3333333333%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 83.3333333333%;
    }
}
</style>
